import { Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GungNotificationService } from 'gung-common';
import { SepaSafeguardService } from '../../services/sepa-safeguard/sepa-safeguard.service';
import { SafeguardOverride } from '../../models/sepa-safeguard';

@Component({
  selector: 'lib-sepa-safeguard-override',
  standalone: false,
  templateUrl: './sepa-safeguard-override.component.html',
  styleUrl: './sepa-safeguard-override.component.scss'
})
export class SepaSafeguardOverrideComponent implements OnInit {
  protected sepaSafeguardService = inject(SepaSafeguardService);
  protected gungNotificationService = inject(GungNotificationService);
  protected translateService = inject(TranslateService);

  activeOverride: SafeguardOverride | null = null;
  reason = '';
  loading = false;
  loaded = false;

  ngOnInit(): void {
    this.loadActiveOverride();
  }

  loadActiveOverride(): void {
    this.sepaSafeguardService.getActiveOverride().subscribe({
      next: override => {
        this.activeOverride = override;
        this.loaded = true;
      },
      error: () => {
        this.activeOverride = null;
        this.loaded = true;
      }
    });
  }

  createOverride(): void {
    if (!this.reason.trim()) {
      return;
    }
    this.loading = true;
    this.sepaSafeguardService.createOverride(this.reason.trim()).subscribe({
      next: override => {
        this.activeOverride = override;
        this.reason = '';
        this.loading = false;
        this.gungNotificationService.notify(
          this.translateService.instant('OVERRIDE_CREATED'),
          null,
          'success'
        );
      },
      error: err => {
        const message = err?.error?.message || this.translateService.instant('ERROR_CREATING_OVERRIDE');
        this.gungNotificationService.notify(message, null, 'danger');
        this.loading = false;
      }
    });
  }
}
